import { createEvent, eventHistory, getAllEvents, updateEvent } from "../controllers/eventController"


export const handleCreateEvent = async (eventData) =>{
    await createEvent(eventData);
    return {
        message: "Event created succesfully"
    }
    
}

export const handleGetAllEvents = async (options = {}) => {
  const { events, lastVisible, firstVisible } = await getAllEvents(options);

  

  return {
    events,
    firstDoc: firstVisible?.id,
    lastDoc: lastVisible?.id || null,
  };
};


export const handleEventHistory = async(
eventId
)=>{

      const res =  await eventHistory({eventId})
      return res
}


export const handleUpdateEvent = async ( data) =>{
    const response = await updateEvent(data);
    return response;
}